import { useNavigate } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import type { SessionPreview } from '../../types';

const statusVariant: Record<string, 'success' | 'warning' | 'default'> = {
  CONFIRMED: 'success',
  PENDING: 'warning',
  COMPLETED: 'default',
};

interface SessionCardProps {
  data: SessionPreview;
}

export function SessionCard({ data }: SessionCardProps) {
  const navigate = useNavigate();
  const name = data.tutorName || data.studentName || 'Unknown';

  return (
    <Card
      className="cursor-pointer hover:shadow-md transition-shadow"
      onClick={() => navigate(data.detailUrl)}
    >
      <CardHeader className="p-4 pb-2">
        <div className="flex items-center justify-between gap-2">
          <CardTitle className="text-sm truncate">{data.subject}</CardTitle>
          <Badge variant={statusVariant[data.status] ?? 'outline'} className="shrink-0">
            {data.status}
          </Badge>
        </div>
      </CardHeader>
      <CardContent className="p-4 pt-0 text-sm text-muted-foreground space-y-1">
        <p>{name}</p>
        <p>{new Date(data.scheduledAt).toLocaleString()}</p>
      </CardContent>
    </Card>
  );
}
